import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "sushiweb/Button";
import FilterButton from "../../components/Common/FilterButton";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverAppReleasesActions from "../../store/actions/DriverAppReleases";
import ListPagination from "../../components/Common/ListPagination";
import AppReleasesList from "../../components/DriverAppReleases/AppReleasesList";
import AppReleasesFilterModal from "../../components/DriverAppReleases/AppReleasesFilterModal";
import { useHistory } from "react-router-dom";
import variables from "../../constants/assets/variables";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import Permission from "../../components/Common/Permission";

const DriverAppReleases = ({
  getAppReleasesList,
  resetState,
  appReleasesList,
  activeFilters,
  nextPage,
  prevPage,
}) => {
  const history = useHistory();
  const [filterModal, setFilterModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.DRIVER_APP_RELEASE];
  const handleClick = (type) => {
    if (type == "Add") {
      history.push("/driver-app-releases/actions?type=create");
    }
  };

  const handleRowClick = (id) => {
    console.log("current id=", id);
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      getAppReleasesList(activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      getAppReleasesList(activeFilters, pageRequest);
    }
  };

  const handleFilterModalOpen = () => {
    setFilterModal(true);
  };

  const handleModalClose = () => {
    setFilterModal(false);
  };

  useEffect(() => {
    appReleasesList.length == 0 && getAppReleasesList();
    resetState({ state: "activeFilters" });
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(activeFilters)]);

  return (
    <DriverAppReleasesContainer>
      <FlexContainer>
        <Heading>Driver App Releases</Heading>
        <div
          style={{ maxWidth: "320px" }}
          className="actionBar mb-20 flex items-center justify-end"
        >
          <Permission requiredPerms={[allActions.UPDATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn mr-16"
              data-testid="createNewAppRelease"
            >
              Create new release
            </Button>
          </Permission>
          <FilterButton
            activeFilters={activeFilters}
            handleClick={handleFilterModalOpen}
          />
        </div>
      </FlexContainer>
      <AppReleasesList
        permissions={allActions}
        list={appReleasesList}
        handleClick={handleRowClick}
      />
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage}
        handleNavClick={handleNavClick}
      />
      {filterModal && (
        <AppReleasesFilterModal handleModalClose={handleModalClose} />
      )}
    </DriverAppReleasesContainer>
  );
};

const DriverAppReleasesContainer = styled.section`
  .file-upload-box {
    margin-bottom: 30px;
    label {
      border: 1px solid ${variables.primaryColor};
      padding: 20px;
      border-radius: 8px;
      max-width: unset;
    }
  }
  .modal-content {
    .file-upload-box label {
      width: 60%;
    }
  }
  .created-at-fields {
    .created-at-container {
      padding: 20px;
      padding-bottom: 0;
    }
    h4 {
      color: ${variables.grey700};
      font-weight: 500;
      margin-top: 40px;
    }
  }
`;

function mapStateToProps(state) {
  const { DriverAppReleases } = state;
  return {
    appReleasesList: DriverAppReleases.appReleasesList,
    activeFilters: DriverAppReleases.activeFilters,
    nextPage: DriverAppReleases.nextPage,
    prevPage: DriverAppReleases.prevPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAppReleasesList: bindActionCreators(
      DriverAppReleasesActions.getAppReleasesList,
      dispatch
    ),
    resetState: bindActionCreators(
      DriverAppReleasesActions.resetState,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverAppReleases);
